/**
 * Mermaid Editor
 * Handles configuration for mermaid diagram display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for mermaid control
 */
function renderMermaidEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Diagram Definition
          <textarea
            value={(control.config?.definition as string) || ''}
            onChange={(e) => onConfigChange('definition', e.target.value)}
            className="af-properties-tab__textarea"
            rows={8}
            placeholder={'graph TD\n  A --> B'}
          />
        </label>
      </div>
    </div>
  );
}

/**
 * MermaidEditor - Handles mermaid control configuration
 */
export const MermaidEditor: PropertyEditor = {
  type: 'mermaid',
  label: 'Mermaid Diagram',
  description: 'Configure Mermaid diagram definition',
  render: renderMermaidEditor,
};
